module.exports = "/_next/static/images/baseballIconActive@3x-2698d71c8f6a1a927745c9a54dc5ced6.png";